function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import * as httpProtocol from './httpProtocol';
import { Constants } from '@shared/utils/constants';
import { getAppConfig } from '@shared/services/init/appConfig';
import { logError } from '@shared/utils/httpClientUtil';
const option = {
    requireCorrelationId: true,
    stringifyPostData: false,
    authenticationType: httpProtocol.AuthenticationTypes.Unauthenticated
};
export function getTileData({ flightCodes, embedHost, billingRegion, requestId, entityType, urlQuery, isConverged }) {
    const endpoint = Constants.Endpoints.View.TileData;
    let _request;
    const tileDataOption = _object_spread_props(_object_spread({}, option), {
        requestId,
        requestCallback: (request)=>_request = request
    });
    const get = httpProtocol.get(endpoint, tileDataOption);
    if (flightCodes) {
        get.addQueryEntry(Constants.QueryStrings.flightCodes, flightCodes);
    }
    if (isConverged) {
        get.addQueryEntry(Constants.QueryStrings.isConverged, 'true');
    }
    if (embedHost) {
        get.addQueryEntry(Constants.QueryStrings.embedHost, embedHost);
    }
    if (billingRegion) {
        get.addQueryEntry(Constants.QueryStrings.billingRegion, billingRegion);
    }
    if (entityType) {
        get.addQueryEntry(Constants.QueryStrings.entityType, entityType);
    }
    if (urlQuery) {
        for(const key in urlQuery){
            if (Object.prototype.hasOwnProperty.call(urlQuery, key)) {
                get.addQueryEntry(key, urlQuery[`${key}`]);
            }
        }
    }
    const data$ = get.request().catch((error)=>{
        logError('getTileData', error);
        return Promise.reject(error);
    });
    return {
        data$,
        request: ()=>_request
    };
}
export function getAppPricing(_) {
    return _getAppPricing.apply(this, arguments);
}
function _getAppPricing() {
    _getAppPricing = _async_to_generator(function*({ entityId, isEmbedded, flightCodes, billingRegion, urlQuery = {} }) {
        let endpoint = `${Constants.Endpoints.View.AppPricing}/${entityId}`;
        if (billingRegion) {
            endpoint += '/' + billingRegion;
        }
        const get = httpProtocol.get(endpoint, option);
        if (isEmbedded) {
            get.addQueryEntry(Constants.QueryStrings.isEmbedded, true.toString());
        }
        if (flightCodes) {
            get.addQueryEntry(Constants.QueryStrings.flightCodes, flightCodes);
        }
        for(const key in urlQuery){
            get.addQueryEntry(key, urlQuery[`${key}`]);
        }
        try {
            return yield get.request();
        } catch (error) {
            logError('getAppPricing', error);
            throw error;
        }
    });
    return _getAppPricing.apply(this, arguments);
}
export function getFuturePrices(_) {
    return _getFuturePrices.apply(this, arguments);
}
function _getFuturePrices() {
    _getFuturePrices = _async_to_generator(function*({ entityId, isEmbedded, billingRegion, flightCodes }) {
        let endpoint = `${Constants.Endpoints.View.AppFuturePricing}/${entityId}`;
        if (billingRegion) {
            endpoint += '/' + billingRegion;
        }
        const get = httpProtocol.get(endpoint, option);
        if (isEmbedded) {
            get.addQueryEntry(Constants.QueryStrings.isEmbedded, true.toString());
        }
        if (flightCodes) {
            get.addQueryEntry(Constants.QueryStrings.flightCodes, flightCodes);
        }
        try {
            return yield get.request();
        } catch (error) {
            logError('getFuturePrices', error);
            throw error;
        }
    });
    return _getFuturePrices.apply(this, arguments);
}
export function getApp(_) {
    return _getApp.apply(this, arguments);
}
function _getApp() {
    _getApp = _async_to_generator(function*({ entityId, flightCodes, isConverged }) {
        const endpoint = `/view/app/${entityId}`;
        const get = httpProtocol.get(endpoint, option);
        if (flightCodes) {
            get.addQueryEntry(Constants.QueryStrings.flightCodes, flightCodes);
        }
        if (isConverged) {
            get.addQueryEntry(Constants.QueryStrings.isConverged, 'true');
        }
        try {
            return yield get.request();
        } catch (error) {
            logError('getApp', error);
            return yield Promise.reject(error);
        }
    });
    return _getApp.apply(this, arguments);
}
export function getAppRelatedAppsItems(entityId, embedHost) {
    const endpoint = `/view/app/${entityId}/relatedApps`;
    const get = httpProtocol.get(endpoint, option);
    if (embedHost) {
        get.addQueryEntry(Constants.QueryStrings.embedHost, embedHost);
    }
    return get.addQueryEntry(Constants.QueryStrings.version, getAppConfig(Constants.apiVersion)).request().catch((error)=>{
        logError('getAppRelatedAppsItems', error);
        return Promise.reject(error);
    });
}
export function getFilteredApps({ billingRegion, flightCodes, embedHost, options: { includeTestProducts = false, isConverged = false } = {}, urlQuery, searchActionType = Constants.Search.ActionType.Search, requestId = '' }) {
    const endpoint = '/view/filteredapps';
    const get = httpProtocol.get(endpoint, option);
    get.setRetry(2);
    if (flightCodes) {
        get.addQueryEntry(Constants.QueryStrings.flightCodes, flightCodes);
    }
    if (includeTestProducts) {
        get.addQueryEntry(Constants.QueryStrings.includeTestProducts, 'true');
    }
    if (isConverged) {
        get.addQueryEntry(Constants.QueryStrings.isConverged, 'true');
    }
    if (embedHost) {
        get.addQueryEntry(Constants.QueryStrings.embedHost, embedHost);
    }
    if (billingRegion) {
        get.addQueryEntry(Constants.QueryStrings.billingRegion, billingRegion);
    }
    for(const key in urlQuery){
        get.addQueryEntry(key, urlQuery[`${key}`]);
    }
    get.addHeader({
        SearchActionType: searchActionType
    });
    return get.addQueryEntry(Constants.QueryStrings.version, getAppConfig(Constants.apiVersion)).setHeader(Constants.Headers.CatalogApiClientRequestId, requestId).request().catch((error)=>{
        logError('getFilteredApps', error);
        return Promise.reject(error);
    });
}
export function getFilteredCloudsIndustry({ urlQuery, requestId, searchActionType = Constants.Search.ActionType.Search }) {
    const queryParams = _object_spread({
        [Constants.QueryStrings.version]: getAppConfig(Constants.apiVersion)
    }, urlQuery);
    const get = httpProtocol.get(Constants.Endpoints.View.CloudsIndustryFiltered, _object_spread_props(_object_spread({}, option), {
        queryParams
    }));
    get.setRetry(2);
    get.addHeader({
        SearchActionType: searchActionType
    });
    return get.setHeader(Constants.Headers.CatalogApiClientRequestId, requestId).request().catch((error)=>{
        logError('getFilteredCloudsIndustry', error);
        return Promise.reject(error);
    });
}
export function getAllAppsPricing(_) {
    return _getAllAppsPricing.apply(this, arguments);
}
function _getAllAppsPricing() {
    _getAllAppsPricing = _async_to_generator(function*({ billingRegion, urlQuery = {} }) {
        let endpoint = Constants.Endpoints.View.AppPricing;
        if (billingRegion) {
            endpoint += '/' + billingRegion;
        }
        const get = httpProtocol.get(endpoint, option);
        for(const key in urlQuery){
            get.addQueryEntry(key, urlQuery[`${key}`]);
        }
        try {
            return get.request();
        } catch (error) {
            logError('getAllAppsPricing', error);
            throw error;
        }
    });
    return _getAllAppsPricing.apply(this, arguments);
}
export function getService({ entityId, flightCodes, isConverged }) {
    const endpoint = `/view/consultingservice/${entityId}`;
    const get = httpProtocol.get(endpoint, option);
    if (flightCodes) {
        get.addQueryEntry(Constants.QueryStrings.flightCodes, flightCodes);
    }
    if (isConverged) {
        get.addQueryEntry(Constants.QueryStrings.isConverged, 'true');
    }
    return get.request().catch((error)=>{
        logError('getServices', error);
        return Promise.reject(error);
    });
}
export function getServiceRelatedAppsItems(entityId, country, region) {
    const endpoint = `/view/consultingservice/${entityId}/relatedServices`;
    const get = httpProtocol.get(endpoint, option);
    if (country) {
        get.addQueryEntry(Constants.QueryStrings.country, country);
    }
    if (region) {
        get.addQueryEntry(Constants.QueryStrings.region, region);
    }
    return get.request().catch((error)=>{
        logError('getServiceRelatedItems', error);
        return Promise.reject(error);
    });
}
export function getFilteredServices({ urlQuery, searchActionType = Constants.Search.ActionType.Search, requestId, options: { includeTestProducts = false, isConverged = false } = {} }) {
    const endpoint = '/view/filteredservices';
    const get = httpProtocol.get(endpoint, option);
    get.setRetry(2);
    for(const key in urlQuery){
        if (Object.prototype.hasOwnProperty.call(urlQuery, key)) {
            get.addQueryEntry(key, urlQuery[`${key}`]);
        }
    }
    if (includeTestProducts) {
        get.addQueryEntry(Constants.QueryStrings.includeTestProducts, 'true');
    }
    if (isConverged) {
        get.addQueryEntry(Constants.QueryStrings.isConverged, 'true');
    }
    get.addHeader({
        SearchActionType: searchActionType
    });
    return get.setHeader(Constants.Headers.CatalogApiClientRequestId, requestId).request().catch((error)=>{
        logError('getFilteredServices', error);
        return Promise.reject(error);
    });
}
export function searchPartners(query, locale, partnersApiHost) {
    return _searchPartners.apply(this, arguments);
}
function _searchPartners() {
    _searchPartners = _async_to_generator(function*(query, locale, partnersApiHost) {
        const searchOption = {
            clientType: 'webBrowser',
            authenticationType: httpProtocol.AuthenticationTypes.Unauthenticated
        };
        const endpoint = `${partnersApiHost}/${Constants.partnersSearchApiRoute}`;
        try {
            return httpProtocol.get(endpoint, searchOption).addQueryEntry(Constants.QueryStrings.searchLocale, locale).addQueryEntry(Constants.QueryStrings.searchQuery, query).request();
        } catch (error) {
            logError('searchPartners error', error);
            return Promise.reject(error);
        }
    });
    return _searchPartners.apply(this, arguments);
}
export function getAppsDataMap({ embedHost }) {
    const endpoint = '/view/appsdatamap';
    const get = httpProtocol.get(endpoint, option);
    if (embedHost) {
        get.addQueryEntry(Constants.QueryStrings.embedHost, embedHost);
    }
    return get.addQueryEntry(Constants.QueryStrings.version, getAppConfig(Constants.apiVersion)).request().catch((error)=>{
        logError('getAppsDataMap', error);
        return Promise.reject(error);
    });
}
export function getCloudsIndustryDataMap() {
    const get = httpProtocol.get(Constants.Endpoints.View.CloudsIndustryDataMap, option);
    return get.addQueryEntry(Constants.QueryStrings.version, getAppConfig(Constants.apiVersion)).request().catch((error)=>{
        logError('getCloudsIndustryDataMap', error);
        return Promise.reject(error);
    });
}
export function getServicesDataMap() {
    const endpoint = '/view/servicesdatamap';
    const get = httpProtocol.get(endpoint, option);
    return get.request().catch((error)=>{
        logError('getServicesDataMap', error);
        return Promise.reject(error);
    });
}
export function getCreateUiDefinition(_) {
    return _getCreateUiDefinition.apply(this, arguments);
}
function _getCreateUiDefinition() {
    _getCreateUiDefinition = _async_to_generator(function*({ createUiDefinitionEndpoint }) {
        const get = httpProtocol.get(createUiDefinitionEndpoint, option);
        return get.request().catch((error)=>{
            logError('getCreateUiDefinition', error);
            return Promise.reject(error);
        });
    });
    return _getCreateUiDefinition.apply(this, arguments);
}
